import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const LoadingErrorWrapper = ({ loading, error, children }) => {
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress color="primary" />
            </Box>
        );
    }

    if (error) {
        return <Typography color="error">Erro ao carregar os dados</Typography>;
    }

    return <>{children}</>;
};

export default LoadingErrorWrapper;
